<template>
  <div id="app">
    <div id="container">
      <div :style="btnStyles">
        <div class="bg-white-2">
          <!-- {{ result }} -->
          <div id="chart">
            <div class="d-flex justify-content-between text-black">
              <div class="col-6 p-1">
                <h1 class="m-0" :style="`color: ${color}`">
                  <b>{{ stock.name }} </b>
                </h1>
                <p class="m-0">{{ currentDate() }}</p>
                <p class="m-0" style="color: rgb(128, 128, 128)">
                  {{ `เวลาจบ ${closeTime()}` }}
                </p>
                <p
                  :class="[
                    'badge m-0',
                    stock.status != 'PAUSE'
                      ? stock.status != 'OPEN'
                        ? 'badge-danger'
                        : 'badge-success'
                      : 'badge-secondary',
                  ]"
                >
                  {{
                    stock.status != "PAUSE"
                      ? stock.status != "OPEN"
                        ? "ปิด"
                        : "เปิด"
                      : "พัก"
                  }}
                </p>
              </div>

              <div class="p-1">
                <div v-for="(data, i) in result" :key="i" :value="data">
                  <div v-if="data.changePercent != 0 && data.change != 0">
                    <div
                      class="text-center mb-1"
                      style="
                        background-color: rgba(255, 255, 255, 0.6);
                        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
                        border: 1px solid rgba(0, 0, 0, 0.1);
                        border-radius: 6px;
                      "
                    >
                      <div class="p-2">
                        <p :class="['m-0 time-box']">
                          {{ `${data.name}` }}
                        </p>
                        <h4 :class="['time-box']">
                          <b>
                            {{
                              `${numberWithCommas(
                                showByDigit(data.value.toFixed(2))
                              )}`
                            }}
                          </b>
                        </h4>
                        <h5
                          :class="[
                            'time-box',
                            data.changePercent >= 0
                              ? 'text-success'
                              : 'text-danger',
                          ]"
                        >
                          {{
                            `${numberWithCommas(
                              showByDigit(data.change.toFixed(2))
                            )}(${showByDigit(data.changePercent.toFixed(2))}%)`
                          }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3 p-1">
              <div>
                <h2 :class="['bd-highlight']">
                  <b>
                    {{
                      `${
                        series[0].data.length > 0
                          ? numberWithCommas(showByDigit(series[0].data[0].y))
                          : "-"
                      }`
                    }}
                  </b>
                </h2>

                <h5
                  :class="[
                    'bd-highlight',
                    current != undefined
                      ? current.changePercent >= 0
                        ? 'text-success'
                        : 'text-danger'
                      : '',
                  ]"
                >
                  {{
                    current != undefined && current.change != undefined
                      ? `${numberWithCommas(
                          showByDigit(current.change.toFixed(2))
                        )}`
                      : "-"
                  }}

                  {{
                    current != undefined && current.changePercent != undefined
                      ? `(${numberWithCommas(
                          showByDigit(current.changePercent.toFixed(2))
                        )}%)`
                      : ""
                  }}
                </h5>
                <p class="m-0 bd-highlight" style="color: rgb(128, 128, 128)">
                  {{
                    series[0].data.length > 0
                      ? Date(series[0].data[count - 1].x).split(" G")[0]
                      : "-"
                  }}
                </p>
              </div>
            </div>
            <apexchart
              type="area"
              height="220"
              ref="realtimeChart"
              :options="chartOptions"
              :series="series"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";

export default {
  name: "app",
  props: {
    stock_id: {
      Type: String,
    },
    stock: {
      Type: Object,
    },
    bg: {
      Type: String,
    },
    color: {
      Type: String,
    },
  },
  components: {},
  computed: {
    btnStyles() {
      return {
        "background-image": `url(${this.stock.background})`,
        "background-position": "center",
        "background-repeat": " no-repeat",
        "background-size": "cover",
        "border-radius": "6px",
      };
    },
  },
  data() {
    return {
      count: 0,
      current: [],
      result: [{ name: "-", value: 0.0, changePercent: 0.0, change: 0.0 }],
      series: [
        {
          name: "Current",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: "area",
          stacked: false,
          height: 350,
          zoom: {
            enabled: false,
          },
          toolbar: {
            autoSelected: "zoom",
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: [this.color],

        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 90, 100],
          },
        },
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },

        yaxis: {
          opposite: true,
          labels: {
            show: true,
            align: "right",
            minWidth: 0,
            maxWidth: 160,
            style: {
              colors: [],
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 400,
              cssClass: "apexcharts-yaxis-label",
            },
            offsetX: 0,
            offsetY: 0,
            rotate: 0,
            formatter: (val) => {
              return val.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
            },
          },
        },
        legend: {
          horizontalAlign: "left",
        },
        tooltip: {},
      },
    };
  },

  mounted() {
    this.getStockResult(), this.getStockValue();
    setInterval(() => {
      this.getStockResult(), this.getStockValue();
    }, 600000);
  },
  methods: {
    showByDigit(val) {
      // if(val.toString().length===5) return val
      // else return (Math.floor(val * 100) / 100).toFixed(2);

      //return (Math.floor(val * 100) / 100).toFixed(2);

      return (
        val.toString().split(".")[0] +
        "." +
        (val.toString().split(".")[1][0] != undefined
          ? val.toString().split(".")[1][0]
          : "0") +
        (val.toString().split(".")[1][1] != undefined
          ? val.toString().split(".")[1][1]
          : "0")
      );
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getStockResult() {
      this.$http
        .get(
          `${process.env.VUE_APP_BACKEND_API_URL}/stock-result/${this.stock_id}`
        )
        .then(({ data }) => {
          if (data.length != 0) this.result = data.reverse();
        })
        .catch((err) => {
          return err;
        });
    },
    getStockValue() {
      this.$http
        .get(
          `${process.env.VUE_APP_BACKEND_API_URL}/stock-value/${this.stock_id}`
        )
        .then(({ data }) => {
          this.series[0].data = [];
          this.count = data.length;
          for (var i = 0; i < data.length; i++) {
            this.series[0].data.push({
              x: data[i].time,
              y: data[i].current,
            });
          }
          this.current = data[0];

          this.updateSeriesLine();
        })
        .catch((err) => {
          return err;
        });
    },
    closeTime() {
      return this.stock.closeTime;
    },
    currentDate() {
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const current = new Date();
      const date = `${current.getDate()} ${
        monthNames[current.getMonth()]
      } ${current.getFullYear()}`;
      return date;
    },
    updateSeriesLine() {
      this.$refs.realtimeChart.updateSeries(
        [
          {
            data: this.series[0].data,
          },
        ],
        false,
        true
      );
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
  },
};
</script>

<style>
html {
  background: #f8f8f8;
}
#app {
  font-family: "Prompt", sans-serif;
  background: #f8f8f8;
}
#header {
  margin: 25px auto;
  width: 800px;
  text-align: center;
}
#chart {
  width: 100%;
}
#container {
  width: 70%;
  /*height: 550px; */
  margin: 25px auto;
  padding: 4px;
}

.bg-white-2 {
  background: rgb(25, 0, 37);
  background: linear-gradient(
    90deg,
    rgb(255, 255, 255) 0%,
    rgba(255, 255, 255, 0.829) 100%
  );
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
}

.bg-purple {
  background: rgb(25, 0, 37);
  background: linear-gradient(
    90deg,
    rgba(25, 0, 37, 1) 0%,
    rgba(71, 0, 88, 1) 100%
  );
  color: white;
}
.bg-static {
  background: rgb(25, 0, 37);
  background: linear-gradient(90deg, rgb(10, 10, 10) 0%, rgb(22, 22, 22) 100%);
  color: black;
}
.time-box {
  font-size: 18px;
}
.p-1 {
  padding: 1.25rem !important;
}

.head-blank {
  margin-top: 40px;
}
.hidden-mobile {
  display: none;
}
@media (max-width: 575.98px) {
  .hidden-pc {
    display: none;
  }
  .hidden-mobile {
    display: block;
  }
  .head-blank {
    margin-top: 10px;
  }
  #container {
    width: 100%;
  }
  h1 {
    font-size: 24px;
  }
  h2 {
    font-size: 21px;
  }
  p {
    font-size: 12px;
  }
  h5 {
    font-size: 12px;
  }
  .time-box {
    font-size: 10px;
  }
  .p-1 {
    padding: 0.25rem !important;
  }
}
</style>
